import { render } from "./Account.vue?vue&type=template&id=735c030e&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=735c030e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-735c030e"

export default script